<template lang="html">
  <v-select
    :value="computedValue"
    :options="localOptions"
    :label= "label"
    :on-change = "change"
    :searchable = "searchable"
    :multiple = "multiple"
    :placeholder = "placeholder"
    :transition = "transition"
    :clearSearchOnSelect = "clearSearchOnSelect"
  />
</template>

<script>
import VSelect from 'vue-select'

export default {
  data () {
    return {
      localOptions: []
    }
  },
  computed: {
    computedValue () {
      for (let value of this.localOptions) {
        if (value.id === this.value) {
          return value
        }
      }
    }
  },
  created () {
    if ((typeof this.options) === 'string') {
      this.$http.get(this.options).then((res) => {
        this.localOptions = res.data
      })
    } else {
      this.localOptions = this.options
    }
  },
  methods: {
    change (val) {
      this.$emit('input', val.id)
    }
  },
  props: {
    value: {
      default: null
    },
    options: {
      type: String | Array
    },
    searchable: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    transition: {
      type: String,
      default: 'expand'
    },
    clearSearchOnSelect: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: 'name'
    },
    onChange: Function
  },
  components: {
    VSelect
  }
}
</script>



// WEBPACK FOOTER //
// ComboBox.vue?3dbfa9e4